import React, { useEffect, useState } from "react";
import Navigation from "../../components/Navigation";
import { Link, useNavigate } from "react-router-dom";
import Constants from "../Variables/Constants";
import axios from "axios";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { Nav } from "react-bootstrap";

const ProfileEditPage = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    mobile_no: "",
  });
  const [userImage, setUserImage] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchUserData = async () => {
    const url = Constants.getUrls.getUserData;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      setUserData(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleUpdate = async () => {
    console.log("userData", userData);
    const url = Constants.postUrls.updateUser;
    const formData = new FormData();

    if (userData.name) {
      formData.append("name", userData.name);
    }

    if (userData.email) {
      formData.append("email", userData.email);
    }

    if (userData.mobile_no) {
      formData.append("mobile_no", userData.mobile_no);
    }

    if (userImage) {
      formData.append("image", userImage);
    }
    try {
      const response = await axios.put(
        url,
        formData,
        // {
        //   name: userData.name,
        //   email: userData.email,
        //   mobile_no: userData.mobile_no,
        // },
        {
          headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: localStorage.getItem("token"),
          },
        }
      );
      if (response.status === 200) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.success("Profile Updated Successfully");
        navigate("/profile");
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error("Something went wrong!");
      }
    } catch (error) {
      console.error("Error updating user data:", error);
    }
  };

  return (
    <>
      <Navigation />
      {loading && <Loader />}
      <div className="container">
        <div className="col-12">
          <div className="editProfile border mx-auto position-relative rounded-4">
            {userImage || userData.profile_pic_url ? (
              <img loading="lazy" 
                className="w-100 bg-warning-light h-100 object-fit-cover rounded-4"
                src={
                  userImage
                    ? URL.createObjectURL(userImage)
                    : userData.profile_pic_url
                      ? `${Constants.imgDomain + userData.profile_pic_url}`
                      : "/bi.png"
                }
              />
            ) : (
              <img loading="lazy" 
                className="w-100 bg-warning-light p-5 h-100 object-fit-contain rounded-4"
                src={"/bi.png"}
              />
            )}

            <input
              type="file"
              style={{ display: "none" }}
              id="user-profile"
              onChange={(e) => {
                setUserImage(e.target.files[0]);
              }}
            />
            <label htmlFor="user-profile">
              <img loading="lazy" 
                className="position-absolute rounded-4 right-0 bottom-0"
                style={{ cursor: "pointer" }}
                src="/camera.png"
                alt=""
              />
            </label>
          </div>

          <div className="card p-4 fs-20 mt-5">
            <div className="row g-3">
              <div className="col-md-4">
                <label htmlFor="name" className="form-label">
                  Name
                </label>
                <input
                  placeholder="Enter your name"
                  type="text"
                  className="form-control border fs-14 rounded-4 p-3"
                  id="name"
                  name="name"
                  value={userData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  placeholder="Enter your Email"
                  type="email"
                  className="form-control border fs-14 rounded-4 p-3"
                  id="email"
                  name="email"
                  readOnly
                  value={userData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 position-relative">
                <label htmlFor="mobile" className="form-label">
                  Mobile No
                </label>
                <input
                  placeholder="Enter your Number"
                  type="text"
                  className="form-control border fs-14 rounded-4 p-3"
                  id="mobile"
                  name="mobile_no"
                  value={userData.mobile_no}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center w-100 mt-4">
            <Link to="/profile">
              <button className="btn btn-light btww me-2 px-5">Cancel</button>
            </Link>
            <button
              type="button"
              className="btn btn-warning btww text-white"
              onClick={handleUpdate}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileEditPage;
